import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import Home from "./pages/home";
import CompanyFormationCorpnetLanding from "./pages/company-formation-corpnet-landing";
import NotFound from "./pages/not-found";

const queryClient = new QueryClient();

export interface CorpNetAppProps {
  /** Page to display: "home", "company-formation", or undefined for default */
  page?: string;
  /** Show navigation bar (default: false) */
  showNavbar?: boolean;
  /** Show footer (default: false) */
  showFooter?: boolean;
  /** Callback when navigation is requested */
  onNavigate?: (page: string) => void;
}

const CorpNetApp: React.FC<CorpNetAppProps> = ({ 
  page = "home",
  showNavbar = false,
  showFooter = false,
  onNavigate
}) => {
  // Scroll to top when page changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page]);
  const getPageComponent = () => {
    switch (page) {
      case "home":
        return <Home showNavbar={showNavbar} showFooter={showFooter} onNavigate={onNavigate} />;
      case "company-formation":
        return <CompanyFormationCorpnetLanding showNavbar={showNavbar} showFooter={showFooter} onNavigate={onNavigate} />;
      default:
        return <NotFound />;
    }
  };

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        {getPageComponent()}
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default CorpNetApp;
